import { createFileRoute } from "@tanstack/react-router";
import { ButtonLink } from "~/components/ButtonLink";
export const Route = createFileRoute("/welcome")({
  component: Home,
});

function Home() {
  return (
    <div className="p-4 items-center justify-center bg-[#f0f0f0] h-full">
      <div className="h-full items-center grid grid-rows-[auto_1fr_auto] relative max-w-2xl mx-auto">
        <div className="z-20 pt-[40%]">
          <h1 className="text-5xl font-bold text-center text-black leading-16">
            Ready to ride?
          </h1>
          <p className="text-xl text-center">Log in and go online</p>
          <img
            src="/images/bike.png"
            alt="Tory Bike Drivers"
            className="w-29 h-29 grid justify-self-center mt-8"
          />
        </div>
        <div className="absolute top-0 w-full h-180 bg-gradient-to-b from-[#f0f0f0] to-transparent z-10" />
        <img
          src="/images/maps.webp"
          alt="Tory Bike Drivers"
          className="w-full object-cover h-full absolute top-1/2 -translate-y-1/2"
        />

        <div className="absolute bottom-0 w-full h-180 bg-gradient-to-t from-[#f0f0f0] to-transparent z-10" />
        <ButtonLink
          className="z-20 absolute bottom-10 left-1/2 -translate-x-1/2"
          to="/login"
        >
          Get Started
        </ButtonLink>
      </div>
    </div>
  );
}
